import React, { useCallback, useEffect, useRef, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Snackbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import jwtDecode from 'jwt-decode';
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import ListPageHeader from "../utilities/ListPageHeader";
import AgGridTable from "../utilities/AgGridTable";
import ShowroomQuestinaries from "./ShowroomQuestinaries";
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {},
}));


export default function Dashboard(props) {
  const navigate = useNavigate();
  const classes = useStyles(props);
  const token = localStorage.getItem('token');
  const [error, setError] = useState();
  const [rowData, setRowData] = useState();
  const perPage = 10;
  const [status, setStatus] = useState();
  const [open, setOpen] = useState(false);
  const [modalName, setModalName] = useState();
  const [user, setUser] = useState();
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const childRef = useRef();
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sno.",
      valueGetter: "node.rowIndex + 1",
      maxWidth: 100,
    },
    { field: "dsTaskId", headerName: "RequestID", enableRowGroup: true },
    { field: "partner", headerName: "Partner Name", enableRowGroup: true },
    { field: "showroom", headerName: "Showroom", enableRowGroup: true },
    { field: "designStudioCategory", headerName: "Type", enableRowGroup: true },
    { field: "createdDate", enableRowGroup: true, headerName: "Create Date" },
    { field: "dsStatus", enableRowGroup: true, headerName: "Status" },
  ]);

  useEffect(() => {
    const decode = jwtDecode(token);
    setUser(decode)
  }, [token])

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    // params.api.sizeColumnsToFit();
    // window.addEventListener('resize', function () {
    //     setTimeout(function () {
    //       params.api.sizeColumnsToFit();
    //     });
    //   });      
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const dsTasListByPartnerId = async (partnerId) => {
    try {
      const list = await OAuthService.getList(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskByPartnerId}?partnerId=${partnerId}`);
      const dsTaskData = list.data?._embedded?.dsTaskAssignments;
      setRowData(dsTaskData);
    } catch (error) {
      console.log(error)
    }
  }

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskList}?page=0&size=1000`);
      const dsTaskData = list.data?._embedded?.dsTaskAssignments;
      setRowData(dsTaskData);
    } catch (error) {
      setError(error.message);
    }
  }

  useEffect(() => {
    if (gridApi) {
      if (token && user && user.company) {
        dsTasListByPartnerId(user.company)
      } else {
        loadData();
      }
    }
  }, [gridApi]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {
    if (params.data.dsStatus === 'DRAFT') {
      setOpen(true);
    } else {
      toast.warning('This request is already scheduled. you can not edit this request')

    }
    setModalName("Update Request")
  }

  const handleClose = () => {
    localStorage.removeItem('dsTask');
    localStorage.removeItem('backAction')
    setOpen(false);
  };

  const handleSave = () => {
    const childelement = childRef.current;
    const submitData = childelement.handleSubmit();
    submitData.then((val) => {
      if (val) {
        setOpen(false);
        loadData();
      }
    })
  }

  const handleSaveAsDraftOrSendPartner = () => {
    localStorage.removeItem('backAction')
    // localStorage.setItem('backAction', false) 
    const childelement = childRef.current;
    const submitData = childelement.handleSaveDraft();
    submitData.then((val) => {
      if (val) {
        setOpen(false);
        // loadData();
      } else {
        console.log("else");
      }
      setOpen(false)
      // navigate('/new-request-calendar')
      // setTabValue(1)
    }).catch((error) => console.log(error))
  }


  const checkedStatus = (st) => {
    setStatus(st)
  }

  return (
    <>
      <ListPageHeader
        componentName="Dashboard"
        pageName="Dashboard"
        showPaginationDropdown={showPaginationDropdown}
      />
      <div className="p-16 sm:p-24 h-full">
        <div className={"h-full"}>
          <AgGridTable
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            gridRef={gridRef}
            onRowDoubleClicked={onRowDoubleClicked}
            onSelectionChanged={onSelectionChanged}
            hideCheckbox={true}
            editable={false}
            pagination={true}
            paginationPageSize={perPage}
          />
        </div>
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        onClose={handleClose}
        open={open}
      // {...other}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>{modalName}</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={handleClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <ShowroomQuestinaries
            id={selectedRows && selectedRows[0]?._links?.dsTaskAssignment?.href.split('/').pop()}
            ref={childRef}
            checkedStatus={checkedStatus}
          />
        </DialogContent>
        <DialogActions className='flex justify-center '>
          <div className='flex justify-center items-center space-x-8'>
            <Button variant="outlined" color="warning" onClick={handleSaveAsDraftOrSendPartner}>Send to Partner </Button>
            <Button variant="outlined" color="warning" onClick={handleSaveAsDraftOrSendPartner}>Save as draft</Button>
            <Button variant="contained" color="warning"
              onClick={handleSave}
              disabled={status}
            >Submit</Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
